import portaro from '../portaro';

portaro.directive('jpVisibleOnHoverParent',
    function() {

        function getHoverElement(element, parameter) {

            if (!parameter) { //neni nastaveno - vratime nadrazeny
                return element.parent();
            }

            var level = parseInt(parameter);
            if (isNaN(level)) {
                //parametr je selector
                var closest = element.closest(parameter);
                if (closest.length > 0) return closest;
                return $(parameter);
            }

            //parametr je level (cislo)
            for (var lev = 0; lev < level; lev++) {
                element = element.parent();
            }
            return element;
        }

        return {
            link: function(scope, element, attrs) {
                var parent = getHoverElement(element, attrs.jpVisibleOnHoverParent);

                if (parent) {
                    element.addClass('jp-hidden');
                    parent.bind('mouseenter', function() {
                        element.removeClass('jp-hidden');
                    });
                    parent.bind('mouseleave', function() {
                        element.addClass('jp-hidden');
                    });
                }
            }
        };
    });